import React, { createContext, useContext, useState } from 'react'

const STORAGE_KEY = 'selectedEventId'

interface SelectedEventForScanContextType {
    selectedEventId: string | null
    setSelectedEventId: (id: string | null) => void
}

const SelectedEventForScanContext = createContext<SelectedEventForScanContextType | undefined>(undefined)

export const SelectedEventForScanProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [selectedEventId, setSelectedEventIdState] = useState<string | null>(() => {
        return localStorage.getItem(STORAGE_KEY)
    })

    const setSelectedEventId = (id: string | null) => {
        setSelectedEventIdState(id)
        if (id) {
            localStorage.setItem(STORAGE_KEY, id)
        } else {
            localStorage.removeItem(STORAGE_KEY)
        }
    }

    return (
        <SelectedEventForScanContext.Provider value={{ selectedEventId, setSelectedEventId }}>
            {children}
        </SelectedEventForScanContext.Provider>
    )
}

export const useSelectedEventForScan = (): SelectedEventForScanContextType => {
    const context = useContext(SelectedEventForScanContext)
    if (!context) {
        throw new Error('useSelectedEventForScan must be used within SelectedEventForScanProvider')
    }
    return context
}
